import React from 'react'

import { mediaQueries, palette } from '@centivo/react-components'
import styled from 'styled-components'

const SearchBarButtonTag = styled.button`
  background-color: #fff;
  border-radius: 4px;
  border: 1px ${palette.neutral['grey-d8d8d8']} solid;
  box-shadow: 1px 2px 4px 0 rgba(68, 68, 68, 0.1),
    -1px -1px 3px 0 rgba(68, 68, 68, 0.06);
  width: 210px;
  height: 150px;
  position: relative;
  cursor: pointer;
  color: ${palette.neutral['primary-body']};

  &:not(:last-child) {
    margin-right: 0.625rem;

    @media ${mediaQueries.desktop} {
      margin-right: 1.25rem;
    }
  }

  span {
    display: block;
    font-size: 1.125rem;
    font-weight: 600;
    margin-top: 1.25rem;
  }

  &.selected {
    background-color: ${palette.teal['50']};
    border-color: ${palette.brand.teal};

    &:before,
    &:after {
      border-style: solid;
      content: '';
      display: block;
      height: 0;
      left: 50%;
      position: absolute;
      top: 100%;
      transform: translateX(-50%);
      width: 0;
      z-index: 0;
    }

    &:before {
      border-color: ${palette.brand.teal} transparent transparent transparent;
      border-width: 22px 13px 0 13px;
    }

    &:after {
      border-color: ${palette.teal['50']} transparent transparent transparent;
      border-width: 20px 12px 0 12px;
    }
  }
`

interface SearchBarButtonProps
  extends Pick<React.HTMLProps<HTMLButtonElement>, 'onClick'> {
  selected: boolean
  icon: React.ReactElement
  title: string
}

export const SearchBarButtonDefault: React.FC<SearchBarButtonProps> = ({
  selected,
  icon,
  title,
  onClick,
}) => {
  const Icon = () => icon
  return (
    <SearchBarButtonTag
      className={selected ? 'selected' : ''}
      onClick={onClick}
    >
      <Icon />
      <span>{title}</span>
    </SearchBarButtonTag>
  )
}
